module.exports = __webpack_public_path__ + "guahao/img/404.55c435f2.png";